import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    download_app_icon: {
        cursor: 'pointer',
        color: '#ffffff',
        display: 'flex',
        marginTop: '-5px',
        marginRight: '8px',
        marginLeft: '15px',
    },
}));

export {useStyles}
